import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateEnvironmentalConditionComponent } from 'app/dialogs/create-environmental-condition/create-environmental-condition.component';
import { EnvironmentalConditionService } from 'app/services/models/environmental-condition.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-environmental-condition-list',
  templateUrl: './environmental-condition-list.component.html',
  styleUrls: ['./environmental-condition-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EnvironmentalConditionListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;

  environmentalCondition: any = '';

  constructor(
    private environmentalService: EnvironmentalConditionService,
    private toastrService: ToastrService,
    private modalService: NgbModal) { }

  async ngOnInit() {
    await this.getAllEnvironmentalCondition(this.pageBasic - 1, this.selectedSize);

    this.environmentalService.event$.subscribe(async rusult => {
      await this.getAllEnvironmentalCondition(this.pageBasic - 1, this.selectedSize);
    })
  }


  showCreateEnvironmentalCondition() {
    this.modalService.open(CreateEnvironmentalConditionComponent, {
      windowClass: 'modal modal-success',
      size: 'lg'
    })
  }

  async getAllEnvironmentalCondition(page, size) {
    const data = await this.environmentalService.getAllEnvironmentalCondition(page, size);
    this.rows = data.environmental;
    console.log(this.rows);
    this.totalCount = data.totalCount;
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllEnvironmentalCondition(this.pageBasic - 1, this.selectedSize);
  }

  formatEnvironmentalContent(content: any[]): string {
    if (!content || content.length === 0) {
      return 'Veri Yok';
    }
    return content.map(ec => `${ec.name} (${ec.start} - ${ec.end})`).join(', ');
  }

  async onPageChange() {
    await this.getAllEnvironmentalCondition(this.pageBasic - 1, this.selectedSize);
  }

  async showUpdateEnvironmetnalContent(id) {
    const modal = this.modalService.open(CreateEnvironmentalConditionComponent, {
      windowClass: 'modal modal-warning',
      size: 'lg'
    });
    modal.componentInstance.data = id;
  }
}